<ag-contact-history
  [service]="studentApiService"
  [referenceId]="studentId"
  (errorGetContacts)="errorGetContactsCallback($event)"
></ag-contact-history>
